import { Box, Button, Grid } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from "react-router-dom";
import { getRoleClaimsSelector } from "../../store/auth/selectors";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import InsituExplorer from "../../components/organisms/insituExplorer/InsituExplorer";

const InsituExtractorList = () => {

    const roles = useSelector(getRoleClaimsSelector);  // roles  - IDP.Admin or IDP.User

    const [isAdmin, setIsAdmin] = useState(true);

    const navigate = useNavigate();

    const addNewInsituExtractor = (event: React.MouseEvent<HTMLButtonElement>) => {
        const url = "/AddInsituCriticality";
        if (event.ctrlKey) {
            window.open(url, '_blank')
        } else {
            navigate(url);
        }
    }

    useEffect(() => {
        if (roles && roles.length > 0) {
            setIsAdmin(roles.includes("IDP.Admin") ? true : false);
        }
    }, [roles]);


    return (
        <>
            <Box sx={{ paddingBottom: "10px" }}>
                <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center">
                    <Grid item xs={8}>
                        <h1 style={{ textAlign: "left" }}>Extractor InSitu Criticality </h1>
                    </Grid>
                    <Grid item xs={4} style={{ textAlign: "right" }}>
                        {isAdmin && <Button id="78ff35c5-a1d4-47c1-a2c2-b22392573f81" color="primary" variant="contained" onClick={addNewInsituExtractor} endIcon={<AddIcon />}>
                            Add New InSitu Extractor Criticality
                        </Button>}
                    </Grid>
                </Grid>
            </Box>
            <InsituExplorer isAdmin={isAdmin} />
        </>
    )
}

export default InsituExtractorList;